import React, { useEffect, useState } from "react";
import Branch from "../../Services/branchServices";

function BranchesList(props) {
  const [branches, setBranches] = useState([]);
  const fetchAllbranches = () => {
    Branch.getAllBranches().then((acc) => {
      setBranches(acc.data);
    });
  };
  useEffect(() => {
    fetchAllbranches();
  }, []);
  return (
    <>
      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header">
            <div class="row">
              <div class="col">
                <h3 class="page-title">Branches Details</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/">Dashboard</a>
                  </li>
                  <li class="breadcrumb-item active">Branch Details</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Branch ID</th>
                          <th>Branch Name</th>
                          <th>Base Currency</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {branches.map((item) => {
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>
                                {item.baseCurrencyName === "USD" ? (
                                  <span class="badge badge-pill badge-info">
                                    {item.baseCurrencyName}
                                  </span>
                                ) : (
                                  <span class="badge badge-pill badge-secondary">
                                    {item.baseCurrencyName}
                                  </span>
                                )}
                              </td>
                              <td>{item.email}</td>
                              <td>{item.phone}</td>
                              <td>{item.createdDate}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BranchesList;
